import styled from "styled-components";
import { TextField } from "@material-ui/core";

export const ActionTextField = styled(TextField)`
    width: 70px;
`;
